<mat-toolbar class="dialog-toolbar">
  <span>Redigera användare</span>
  <span class="example-spacer"></span>
</mat-toolbar>

<form [formGroup]="editUserForm" (ngSubmit)="editUser()" class="edit-user-form">
  <mat-dialog-content class="edit-user-dialog-content">
    <mat-form-field appearance="outline" disabled>
      <mat-label>Välj Användarroll</mat-label>
      <mat-select formControlName="roles" multiple>
        <mat-option value="" disabled>Välj Användarroll</mat-option>
        @for (role of rolesOptions; track role) {
        <mat-option [value]="role.name">
          {{ role.name }}
        </mat-option>
        }
      </mat-select>
    </mat-form-field>

    <mat-form-field appearance="outline" disabled>
      <mat-label>Välj Behörighet</mat-label>
      <mat-select formControlName="accessLevel">
        <mat-option value="" selected disabled>Välj Behörighet</mat-option>
        @for (accessLevel of accessLevelOptions; track accessLevel) {
        <mat-option [value]="accessLevel.value">
          {{ accessLevel.viewValue }}
        </mat-option>
        }
      </mat-select>
    </mat-form-field>

    <mat-form-field appearance="outline">
      <mat-label>Förnamn</mat-label>
      <input matInput placeholder="Namn" formControlName="firstname" [value]="user.firstname">
      <mat-icon matSuffix>person</mat-icon>
      @if (editUserForm.controls.firstname.errors) {
      <mat-error>Skriv in förnamn</mat-error>
      }
    </mat-form-field>

    <mat-form-field appearance="outline">
      <mat-label>Efternamn</mat-label>
      <input matInput placeholder="Namn" formControlName="lastname" [value]="user.lastname">
      <mat-icon matSuffix>person</mat-icon>
      @if (editUserForm.controls.lastname.errors) {
      <mat-error>Skriv in efternamn</mat-error>
      }
    </mat-form-field>

    <mat-form-field appearance="outline">
      <mat-label>Email</mat-label>
      <input matInput placeholder="Email" formControlName="email" [value]="user.email">
      <mat-icon matSuffix>email</mat-icon>
      @if (editUserForm.controls.email.errors) {
      <mat-error>Skriv in mailadress</mat-error>
      }
    </mat-form-field>

    <mat-form-field appearance="outline">
      <mat-label>Telefon</mat-label>
      <input matInput placeholder="Telefonnummer" formControlName="mobile" [value]="user.mobile">
      <mat-icon matSuffix>phone</mat-icon>
      @if (editUserForm.controls.mobile.errors) {
      <mat-error>Skriv in telefonnummer</mat-error>
      }
    </mat-form-field>

    <div class="checkbox-container">
      <mat-checkbox class="mr-2" formControlName="smsVerification" [value]="user.smsVerification">2FA</mat-checkbox>
      <mat-checkbox class="mr-2" formControlName="isApproved" [value]="user.isApproved">Aktiv</mat-checkbox>
      <br>
      <mat-checkbox class="mr-2" formControlName="mabiStaff" [value]="user.mabiStaff">Mabi</mat-checkbox>
      <mat-checkbox class="mr-2" formControlName="flygetsDriver" [value]="user.flygetsDriver">Flygets
        Driver</mat-checkbox>
      <mat-checkbox class="mr-2" formControlName="flygetsDashboard" [value]="user.flygetsDashboard">Flygets
        Dashboard</mat-checkbox>
      <mat-checkbox class="mr-2" formControlName="flygetsParkiflyAdministrator"
        [value]="user.flygetsParkiflyAdministrator">Flygets Parkifly Admin</mat-checkbox>
      <mat-checkbox class="mr-2" formControlName="flygetsParkingOperator" [value]="user.flygetsParkingOperator">Flygets
        Operator</mat-checkbox>
      <mat-checkbox class="mr-2" formControlName="flygetsParkingAdministrator"
        [value]="user.flygetsParkingAdministrator">Flygets Admin</mat-checkbox>
      <mat-checkbox class="mr-2" formControlName="flygetsShuttleDriver" [value]="user.flygetsShuttleDriver">Flygets
        ShuttleDriver</mat-checkbox>
      <mat-checkbox class="mr-2" formControlName="flygetsParkingSurveillance"
        [value]="user.flygetsParkingSurveillance">Flygets Surveillance</mat-checkbox>
      <mat-checkbox class="mr-2" formControlName="scandicStaff" [value]="user.scandicStaff">Scandic</mat-checkbox>
      <mat-checkbox class="mr-2" formControlName="qualityStaff" [value]="user.qualityStaff">Quality</mat-checkbox>
      <mat-checkbox class="mr-2" formControlName="apartDirectStaff"
        [value]="user.apartDirectStaff">ApartDirect</mat-checkbox>
      <mat-checkbox class="mr-2" formControlName="arlandaXPOApartmentsStaff"
        [value]="user.arlandaXPOApartmentsStaff">Arlanda XPO Apartments</mat-checkbox>
      <mat-checkbox class="mr-2" formControlName="skavstaStaff" [value]="user.skavstaStaff">Skavsta</mat-checkbox>
      <mat-checkbox class="mr-2" formControlName="skavstaParkiflyAdministrator"
        [value]="user.skavstaParkiflyAdministrator">Skavsta Parkifly Admin</mat-checkbox>
      <mat-checkbox class="mr-2" formControlName="skavstaParkingOperator" [value]="user.skavstaParkingOperator">Skavsta
        Operator</mat-checkbox>
      <mat-checkbox class="mr-2" formControlName="skavstaParkingAdministrator"
        [value]="user.skavstaParkingAdministrator">Skavsta Admin</mat-checkbox>
      <mat-checkbox class="mr-2" formControlName="skavstaShuttleDriver" [value]="user.skavstaShuttleDriver">Skavsta
        ShuttleDriver</mat-checkbox>
      <mat-checkbox class="mr-2" formControlName="skavstaParkingSurveillance"
        [value]="user.skavstaParkingSurveillance">Skavsta Surveillance</mat-checkbox>
    </div>
  </mat-dialog-content>

  <mat-dialog-actions class="dialog-actions">
    <button mat-stroked-button type="button" (click)="openForgotPassword()">
      SKICKA NYTT LÖSENORD <mat-icon>send</mat-icon>
    </button>
    <div class="right-buttons">
      <button mat-raised-button color="warn" type="button" (click)="cancelForm()">AVBRYT</button>
      <button mat-raised-button color="primary" type="submit">SPARA ÄNDRINGAR</button>
    </div>
  </mat-dialog-actions>
</form>